import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchDesignDataThunk } from './designThunk';
import { templateType } from '../../../designer/designs/[designId]/DesignDetails/templateCard'
const initialState: any = {
    design: {
        designData: {
        },
        loading: true,
        error: false,
    }
};

const designSlice = createSlice({
    name: 'design',
    initialState,
    reducers: {
        updatePhotoRealisticImageUrl: (state, action) => {
            const { templateId, imageUrl } = action.payload;
            const template = state.design.designData.templates.find((t: any) => t.templateId === templateId);
            if (template) {
                template.photoRealisticImageUrl = imageUrl;
            }
        },
        deleteTemplateByType: (state, action) => {
            const { templateId, type, imageUrlToRemove } = action.payload;
            const templates = state.design.designData.templates;

            const index = templates.findIndex((t: any) => t.templateId === templateId);
            if (index === -1) return;

            if (type === templateType.snapShotImage) {
                // Remove whole object
                templates.splice(index, 1);
            } else if (type === templateType.photoRealisticImage) {
                // Remove photoRealisticImageUrl
                delete templates[index].photoRealisticImageUrl;
            } else if (type === templateType.lifeStyleImage) {
                // Remove from lifestyleImageUrls
                const currentImages = templates[index].lifestyleImageUrls || [];
                templates[index].lifestyleImageUrls = currentImages.filter(
                    (url: string) => url !== imageUrlToRemove
                );
            }
        },
        restoreTemplate: (state, action) => {
            const template = action.payload;
            state.design.designData.templates.push(template);
        },
        restorePhotoRealisticImage: (state, action) => {
            const { templateId, imageUrl } = action.payload;
            const template = state.design.designData.templates.find((t: any) => t.templateId === templateId);
            if (template) {
                template.photoRealisticImageUrl = imageUrl;
            }
        },
        restoreLifestyleImage: (state, action) => {
            const { templateId, imageUrl } = action.payload;
            const template = state.design.designData.templates.find((t: any) => t.templateId === templateId);
            if (template) {
                if (!template.lifestyleImageUrls) {
                    template.lifestyleImageUrls = [];
                }
                template.lifestyleImageUrls.push(imageUrl);
            }
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDesignDataThunk.pending, (state) => {
                state.design.loading = true;
                state.design.error = null;
            })
            .addCase(fetchDesignDataThunk.fulfilled, (state, action: PayloadAction<any>) => {
                state.design.designData = action.payload;
                state.design.loading = false;
            })
            .addCase(fetchDesignDataThunk.rejected, (state, action) => {
                state.design.loading = false;
                state.design.error = action.error.message || 'Something went wrong';
            });
    },
});
export const { actions: designActions } = designSlice
export default designSlice.reducer;
